














import Vue from 'vue';
import {ItineraryPreferenceTab} from './itinerary-preferences-helper';
import SectionTab from './section-tab.vue';

export default Vue.extend({
  name: 'ItineraryPreferences',
  components: {
    SectionTab,
  },
  props: ['tabs', 'currentTab'],
  methods: {
    onTabSelect(tabName: ItineraryPreferenceTab) {
      this.$emit('tab-selected', tabName);
    },
  },
});
